
import { Container, } from '@mui/material';
import React from 'react';
import Break from '../../components/Break';
import RandomImage from '../../components/RandomImage';
import Consolas from '../../fonts/Consolas';
import { DUMMY, PARAGRAPH, TITLE } from '../../helper/constants';
import { bio } from './helper';
import { optionalString } from '../../helper/functions';

const Home = (): JSX.Element =>
(
    <div className='Home'>
        <Consolas align="center" as={TITLE} variant="h1">
            Alan Ngo
        </Consolas>

        {/* Personal Picture */}
        <Container><RandomImage /></Container>
        <Break />

        {/* Description */}
        <Container maxWidth={'xl'}>
            <Consolas align="center" as={PARAGRAPH}>{optionalString(bio, DUMMY)}</Consolas>
        </Container>
        <Break />

    </div>
)

export default Home;
